import Footer from './Footer';
import Topbar from './Topbar';
import remoteFromParkSetting from './remote-from-park-setting.jpg';
import stopwatch from './stopwatch-tophalf.png';
import football from './football-wideangle.jpg';

export default function Culture() {
    return (
    <div>
      <Topbar />
      <div className="bg-gray-50 py-16 sm:py-24">
        <div className="mx-auto px-3 lg:max-w-7xl lg:px-3">
          <p className="mx-auto mt-2 max-w-lg text-balance text-center text-2xl font-semibold tracking-tight text-gray-950 sm:text-3xl">
            Purpose, Performance, Coaching, and Ownership
          </p>
          <div className="mt-6 grid gap-4 sm:mt-8 lg:grid-cols-3 lg:grid-rows-2">
            <div className="relative lg:row-span-2">
              <div className="absolute inset-px rounded-lg bg-white lg:rounded-l-[2rem]"></div>
              <div className="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] lg:rounded-l-[calc(2rem+1px)]">
                <div className="px-8 pb-3 pt-4 sm:px-10 sm:pb-0 sm:pt-5 culture-panel-description">
                  <p className="mt-1 text-lg text-center font-medium tracking-tight text-gray-950 max-lg:text-center">
                    Purpose
                  </p>
                  <p className="mt-1 mb-3 max-w-lg text-center text-gray-600 md:text-center max-lg:text-center">
                    Remote work is here to stay, we don't care where you work, we provide the tools and support you need to be successful.
                  </p>
                </div>
                <div className="relative min-h:max-w-sm w-full grow [container-type:inline-size]">
                    <img
                      className="size-full object-cover object-top"
                    //   src="https://tailwindui.com/plus/img/component-images/bento-03-mobile-friendly.png"
                    src={remoteFromParkSetting}
                    alt=""
                    />
                </div>
              </div>
              <div className="pointer-events-none absolute inset-px rounded-lg shadow ring-1 ring-black/5 lg:rounded-l-[2rem]"></div>
            </div>
            <div className="relative max-lg:row-start-1">
              <div className="absolute inset-px rounded-lg bg-white max-lg:rounded-t-[2rem]"></div>
              <div className="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] max-lg:rounded-t-[calc(2rem+1px)]">
                <div className="px-8 pt-4 sm:px-10 sm:pt-5 text-center items-center culture-panel-description">
                  <p className="mt-1 text-lg font-medium tracking-tight text-center text-gray-950 max-lg:text-center">Performance</p>
                  <p className="mt-1 mb-3 max-w-lg text-gray-600 items-center">
                    We focus on metrics in order to help you grow and develop into your career.  Think of it as constantly trying to beat your best time.  We strive for excellence while thoughtfully growing our people.
                  </p>
                </div>
                <div className="flex flex-1 items-center justify-center px-8 max-lg:pb-12 max-lg:pt-10 sm:px-10 lg:pb-2">
                  <img
                    className="w-full max-lg:max-w-xs"
                    // src="https://tailwindui.com/plus/img/component-images/bento-03-performance.png"
                    src={stopwatch}
                    alt=""
                  />
                </div>
              </div>
              <div className="pointer-events-none absolute inset-px rounded-lg shadow ring-1 ring-black/5 max-lg:rounded-t-[2rem]"></div>
            </div>
            <div className="relative max-lg:row-start-3 lg:col-start-2 lg:row-start-2">
              <div className="absolute inset-px rounded-lg bg-white"></div>
              <div className="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)]">
                <div className="px-8 pt-4 sm:px-10 sm:pt-5">
                  <p className="mt-1 text-lg font-medium text-gray-950 text-center">Coaching & Mentoring</p>
                  <p className="mt-1 mb-3 max-w-lg text-gray-600 text-center">
                    The journey is better together and everyone is required to both give and receive coaching.  Through purposeful pairings you will have the opportunity to learn from some of the best in the business.
                  </p>
                </div>
                <div className="relative min-h:max-w-sm w-full grow [container-type:inline-size]">
                <img
                      className="size-full object-cover object-top"
                    src={football}
                    alt=""
                    />
                </div>
              </div>
              <div className="pointer-events-none absolute inset-px rounded-lg shadow ring-1 ring-black/5"></div>
            </div>
            <div className="relative lg:row-span-2">
              <div className="absolute inset-px rounded-lg bg-white max-lg:rounded-b-[2rem] lg:rounded-r-[2rem]"></div>
              <div className="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] max-lg:rounded-b-[calc(2rem+1px)] lg:rounded-r-[calc(2rem+1px)]">
                <div className="px-8 pb-3 pt-4 sm:px-10 sm:pb-0 sm:pt-5">
                  <p className="mt-1 text-lg font-medium text-center tracking-tight text-gray-950 max-lg:text-center">
                    Ownership
                  </p>
                  <p className="mt-1 mb-3 max-w-lg text-gray-600 text-center md:text-center max-lg:text-center">
                    Our team expects everyone to have an objective opinion, to develop software backed by industry best practices, and to defend architectural decisions.
                  </p>
                </div>
                <div className="relative min-h-[30rem] w-full grow">
                  <div className="absolute bottom-0 left-10 right-0 top-10 overflow-hidden rounded-tl-xl bg-gray-900 shadow-2xl">
                    <div className="flex bg-gray-800/40 ring-1 ring-white/5">
                      <div className="-mb-px flex text-sm/6 font-medium text-gray-400">
                        <div className="border-b border-r border-b-white/20 border-r-white/10 bg-white/5 px-4 py-2 text-white">
                          README.md
                        </div>
                        <div className="border-r border-gray-600/10 text-white px-4 py-2">FindLargest</div>
                      </div>
                    </div>
                    <div className="px-6 pb-14 pt-6 text-gray-400">
                        BEGIN<br/>
                            INPUT list_of_numbers<br/>
                            largest = list_of_numbers[0]<br/>
                            FOR each number IN list_of_numbers<br/>
                                IF number &gt; largest THEN<br/>
                                    largest = number<br/>
                                ENDIF<br/>
                            ENDFOR<br/>
                            PRINT largest<br/>
                        END<br/>
                    </div>
                  </div>
                </div>
              </div>
              <div className="pointer-events-none absolute inset-px rounded-lg shadow ring-1 ring-black/5 max-lg:rounded-b-[2rem] lg:rounded-r-[2rem]"></div>
            </div>
          </div>
        </div>
        <div className="mx-auto max-w-7xl px-8 py-8 sm:py-8 lg:flex lg:items-center lg:justify-between lg:px-8">
            <h1 className="text-2xl tracking-tight text-gray-900 sm:text-3xl">
            Apply now . . . adventure awaits! 
            <br />
            </h1>
            <div className="mt-10 flex items-center gap-x-6 lg:mt-0 lg:flex-shrink-0">
            <a
                href="/jointeam"
                className="rounded-md bg-gray-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
                Apply
            </a>
            <a href="/contact" className="text-sm font-semibold leading-6 text-gray-900">
                Let's talk! <span aria-hidden="true">→</span>
            </a>
            </div>
        </div>
      </div>
    <Footer />    
    </div>
    )
  }